const env: IPlayUIGlobals =
  "undefined" !== typeof process ? (process as any).env : {};

const config = {
  ENV: env.NODE_ENV,
  BUILD_DATE: env.__BUILD_DATE__,
  VERSION: env.__VERSION__
};

// tslint:disable-next-line:no-default-export
export default config;
